import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lable',
  imports: [CommonModule],
  templateUrl: './lable.html'
})
export class LabelComponent {
  @Input() for?: string;
  @Input() className = '';
}
